import { Box, createStyles, makeStyles, Typography } from '@material-ui/core';

import { Checkbox, ConfirmDialog } from 'components/UI';
import React, { useState } from 'react';

interface DeclineConfirmationProps {
    loading: boolean;
    onCancel: () => void;
    onConfirm: (sendNotification: boolean) => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        confirmDialog: {
            '& .MuiDialog-paperWidthSm': {
                maxWidth: 455
            }
        },
        confirmDialogCheckboxContainer: {
            display: 'flex',
            padding: '0px 32px'
        },
        confirmDialogCheckboxText: {
            color: '#7A7A7A',
            textAlign: 'left'
        }
    })
);

const DeclineConfirmation: React.FC<DeclineConfirmationProps> = props => {
    const classes = useStyles();
    const [sendDeclineNotification, setSendDeclineNotification] = useState(true);

    return (
        <ConfirmDialog
            open={true}
            processing={props.loading}
            className={classes.confirmDialog}
            title={<Typography>Decline Appointment</Typography>}
            question={<Typography>Are you sure you want to decline this appointment?</Typography>}
            subquestion={
                <Box className={classes.confirmDialogCheckboxContainer}>
                    <Checkbox
                        checked={sendDeclineNotification}
                        onChange={() => setSendDeclineNotification(!sendDeclineNotification)}
                        label=" "
                    />
                    <Box>
                        <Typography className={classes.confirmDialogCheckboxText}>
                            Send a notification to the customer that their appointment has been decline.
                        </Typography>
                    </Box>
                </Box>
            }
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Decline"
            onCancel={props.onCancel}
            onConfirm={() => props.onConfirm(sendDeclineNotification)}
        />
    );
};

export default DeclineConfirmation;
